import {
  appRecordAbiDataMenuItem,
  createQueryUsIorKebabMenuItem,
  createUsIorCreate5106KebabMenuItem,
  createUsIorUpdate5106KebabMenuItem,
  createUsIorRequestCbpAssignedNumberKebabMenuItem,
  inquireWorkOrderItem,
  unblockWorkOrderItem,
  appRecordSendAbiMessage,
  appRecordAssignWorkOrderTaskMenuItem,
  applyAdditionalKebabMenuItemShowConditions,
} from '../../../utils';
import { AppRecordKebabMenuItem } from '../../../../types';

/**
 * Modifies a list of KebabMenuItems with an additional `show` condition to ensure they only appear for Us IE Activations
 * @param {AppRecordKebabMenuItem[]} originalItems - the KebabMenuItems to modify
 * @return {AppRecordKebabMenuItem[]} - the original list of kebab menu items, modified to `show` only for US IE Activations
 */
export const showOnlyForUsUseCase = (
  originalItems: AppRecordKebabMenuItem[],
): AppRecordKebabMenuItem[] => {
  return applyAdditionalKebabMenuItemShowConditions(originalItems, [
    ({ existingRecord }) => {
      return existingRecord.usIor;
    },
  ]);
};

const pathToUsIor = ['usIor'];
const usOnlyKebabMenuItems = showOnlyForUsUseCase([
  appRecordAbiDataMenuItem,
  appRecordSendAbiMessage,
  createQueryUsIorKebabMenuItem(pathToUsIor),
  createUsIorCreate5106KebabMenuItem(pathToUsIor),
  createUsIorUpdate5106KebabMenuItem(pathToUsIor),
  createUsIorRequestCbpAssignedNumberKebabMenuItem(pathToUsIor),
]);

const generalKebabMenuItems = [
  appRecordAssignWorkOrderTaskMenuItem,
  inquireWorkOrderItem,
  unblockWorkOrderItem,
];

export const importerEntityActivationKebabMenuItems = [
  ...generalKebabMenuItems,
  ...usOnlyKebabMenuItems,
];
